export default __webpack_public_path__ + "static/media/logoimg.36ce60d4.png";